import { render, staticRenderFns } from "./comHome1.vue?vue&type=template&id=1bc5b04a&scoped=true&"
import script from "./comHome1.vue?vue&type=script&lang=js&"
export * from "./comHome1.vue?vue&type=script&lang=js&"
import style0 from "./comHome1.vue?vue&type=style&index=0&id=1bc5b04a&scoped=true&lang=css&"
import style1 from "./comHome1.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc5b04a",
  null
  
)

export default component.exports